import { render, staticRenderFns } from "./CRUDNotasFiscais.vue?vue&type=template&id=67b88ef1&scoped=true&"
import script from "./CRUDNotasFiscais.vue?vue&type=script&lang=js&"
export * from "./CRUDNotasFiscais.vue?vue&type=script&lang=js&"
import style0 from "./CRUDNotasFiscais.vue?vue&type=style&index=0&id=67b88ef1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b88ef1",
  null
  
)

export default component.exports